'use client'

import { MemberGraftabilityHint } from '@/core/components/MemberGraftabilityHint'
import { CallableTitle } from '@/core/hooks/useCardNavigation/components/CallableTitle/CallableTitle'
import type { ParameterData } from '@/core/types/library.type'
import type { GraftabilityIssue } from '@/core/utils/graftability'

import styles from './CallableTitleWithGraftabilityHint.module.scss'

interface CallableTitleWithGraftabilityHintProps {
  name: string
  parameters: ParameterData[]
  issues: GraftabilityIssue[]
}

export function CallableTitleWithGraftabilityHint({
  name,
  parameters,
  issues,
}: CallableTitleWithGraftabilityHintProps) {
  return (
    <span className={styles.wrapper}>
      <CallableTitle name={name} parameters={parameters} />
      <MemberGraftabilityHint issues={issues} />
    </span>
  )
}
